import { Context, createContext } from 'react';
import { Brand, Market } from '@org-avp/models';
import {
  GiveawayResponse,
  TaskStatus,
  DataSourceTypes,
  CommercialVehicleType,
} from '@org-avp/avp-hck-dga-customerui-commons';
import { toInitialLanguage } from '@/i18n/i18n';
import type { OrderPrice } from '@/util/currency';

interface ModelState {
  imageModal?: {
    isOpen: boolean;
    imageSrc: string;
  };
  setImageModal?: React.Dispatch<React.SetStateAction<{ isOpen: boolean; imageSrc: string }>>;
}

type GiveawayContextState = GiveawayResponse &
  ModelState & {
    touchPoint?: string;
    pricing?: OrderPrice;
  };

export type { GiveawayContextState };

export const initialState: GiveawayContextState = {
  id: '',
  assets: [],
  dealerAssets: [],
  marketingCode: '',
  dataSource: DataSourceTypes.OKAPI,
  dealerLink: '',
  dealerAddress: '',
  dealerId: '',
  giveawayStatus: TaskStatus.ACCEPTED,
  brand: Brand.VW,
  market: Market.DEU,
  locale: toInitialLanguage(navigator.language),
  carModel: '',
  createdAt: '',
  prString: '',
  updatedAt: '',
  renderCameraFlight: false,
  consumptionAndEmissionData: {
    fuels: {},
  },
  keyFacts: undefined,
  cameraFlightVideo: '',
  equipmentOptions: [],
  commercialVehicleType: CommercialVehicleType.UNKNOWN,
  isCertifiedPreOwned: false,
  engineType: undefined,
  technicalData: [],
  stockLink: undefined,
  touchPoint: undefined,
};

export const GiveawayContext: Context<GiveawayContextState> = createContext(initialState);
